import { render, staticRenderFns } from "./DeleteConfirmModal.vue?vue&type=template&id=4b94302a&scoped=true&"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmModal.vue?vue&type=style&index=0&id=4b94302a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94302a",
  null
  
)

export default component.exports